import { XClose } from '@tripleten/icons/line/x-close.tsx';

import { cnMessageToast } from './message-toast.constants.js';

import './message-toast.css';

interface MessageToastProp {
    message: string;
    onClose: VoidFunction;
}

export const MessageToast = ({ message, onClose }: MessageToastProp) => (
    <div className={cnMessageToast()}>
        <div className={cnMessageToast('content')}>
            <button onClick={onClose} className={cnMessageToast('close-button')}>
                <XClose size={24} />
            </button>
            {message
                .replaceAll('<br>', '\n')
                .split('\n')
                .map((m, idx) => (
                    <div key={idx}>{m}</div>
                ))}
        </div>
    </div>
);
